import { Component } from 'react';
import moment from 'moment';

import { DateRangePicker } from 'react-dates';

const DEFAULT_ACCESS_WINDOW_DAYS = 7;

class DateRangePickerWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            focusedInput: null,
        };

        this.onDatesChange = this.onDatesChange.bind(this);
    }

    onDatesChange({ startDate, endDate }) {
        let updatedEndDate = endDate;
        if (startDate && !endDate) {
            updatedEndDate = addDefaultAccessWindowDays(startDate);
        }

        this.setState({
            startDate,
            endDate: updatedEndDate,
        });

        this.props.onChange(startDate, updatedEndDate);
    }

    render() {
        return (
            <DateRangePicker
                startDate={this.state.startDate}
                startDateId='start_date'
                endDate={this.state.endDate}
                endDateId='end_date'
                onDatesChange={this.onDatesChange}
                focusedInput={this.state.focusedInput}
                onFocusChange={focusedInput => this.setState({ focusedInput })}
                minimumNights={1}
                hideKeyboardShortcutsPanel
                data-cy="DateRangePicker"
            />
        );
    }
}

function addDefaultAccessWindowDays(startDate) {
    return moment(startDate).add(DEFAULT_ACCESS_WINDOW_DAYS, 'days');
}

export default DateRangePickerWrapper;
